import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

const Linear_Send = View.extend({
    send_options: null,
    fields: {},

    team_id: '',
    project_id: '',
    assignee_id: '',
    title: '',
    labels: [],

    form_value : {
        title: ''
    },

    events: {
        'click .dropdown-team li'               : 'onSelectTeam',
        'click .dropdown-project li'            : 'onSelectProject',
        'click .dropdown-assignee li'           : 'onSelectAssignee',
        'click .dropdown-label li'              : 'onSelectLabel',
        'click .dropdown-label .badge-btn .btn' : 'onRemoveLabel',
        'submit form'                           : 'onSubmit',
        'click .reconnect'                      : 'onReconnect'
    },

    dom_handlers: {

        onSelectTeam: function (e) {
            this.team_id = `${$(e.currentTarget).data('id')}`;
            const current_projects = this.send_options.projects[this.team_id];
            this.project_id = Object.entries(current_projects).length > 0
                ? Object.entries(current_projects)[0][0]
                : '';
            this.renderTeams();
            this.renderProjects();
        },

        onSelectProject: function (e) {
            this.project_id = $(e.currentTarget).data('id');
            this.renderProjects();
        },

        onSelectAssignee: function (e) {
            this.assignee_id = $(e.currentTarget).data('id');
            this.renderAssignees();
        },

        onSelectLabel: function (e) {
            const label = $(e.currentTarget).data('id');

            if (!label) {
                return;
            }

            if (this.labels.includes(label)) {
                this.labels.splice(this.labels.indexOf(label), 1);
            } else {
                this.labels.push(label);
            }

            this.renderLabels();
        },

        onRemoveLabel: function (e) {
            e.stopPropagation();
            const label = $(e.currentTarget).next('input:checkbox').val();
            this.labels.splice(this.labels.indexOf(label), 1);
            this.renderLabels();
        },

        onSubmit: function () {
            const form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            let progress = 0;
            const timeout = setInterval(() => {
                progress = Math.min(90, progress + Math.random() * 15);
                this.$el.find('.progress-loader').width(`${progress}%`);
            }, 50);

            const data = { ...form_data, feedback_id: this.model.get('id') };

            Cache.app.request({
                action: 'integration/sendFeedbackToLinear',
                context: this,
                data,
                success: function (response) {
                    this.model.set('linear_url', response.linear_url);

                    setTimeout(() => {
                        UI.success('Task created in Linear');
                        this.trigger('submit:success');
                    }, 800); // wait for animation to finish
                },
                complete: function () {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        },

        onReconnect: function () {
            var connected_app = Cache.connected_app_oauth.get(Cache.integration_linear.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.sendToLinear(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        }
    },

    initialize: function () {
        this.form_value = {
            title: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = `Feedback for ${this.model.get('page')}`;
        } else {
            this.title = `Feedback #${Util.padLeft(this.model.id, '000000')}`;
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }

        this.fields = {};
    },

    loadOptions: function () {
        const cache_key = 'linear_send_options_' + Cache.integration_linear.findWhere({project_id: this.model.get('project_id')})?.get('linear_board_id') || '';

        if (Cache.get(cache_key)) {
            this.loadOptionsSuccess(Cache.get(cache_key));
        } else {
            Cache.app.request({
                action: 'integration/loadSendOptions',
                data: {
                    type: 'linear',
                    project_id: this.model.get('project_id')
                },
                context: this,
                success: function (response) {
                    if (Object.keys(response.teams).length) {
                        Cache.add(cache_key, response, false);
                        this.loadOptionsSuccess(response);
                    } else {
                        this.renderError();
                    }
                },
                error: function () {
                    this.renderError();
                }
            });
        }
    },

    loadOptionsSuccess: function (response) {
        this.team_id      = Cache.integration_linear.findWhere({project_id: this.model.get('project_id')})?.get('linear_team_id')     || '';
        this.project_id   = Cache.integration_linear.findWhere({project_id: this.model.get('project_id')})?.get('linear_project_id')  || '';
        this.assignee_id  = Cache.integration_linear.findWhere({project_id: this.model.get('project_id')})?.get('linear_assignee_id') || '';
        this.labels       = Cache.integration_linear.findWhere({project_id: this.model.get('project_id')})?.get('linear_labels') || [];
        this.send_options = response;
        this.send_options.users = { '': 'Unassigned', ...this.send_options.users };
        this.render();
    },

    searchTeam: function (team_id) {
        return this.send_options?.teams[team_id] || '';
    },

    searchProject: function (project_id) {
        return this.send_options?.projects?.[this.team_id]?.[project_id] || '';
    },

    searchAssignee: function (assignee_id) {
        return this.send_options?.users[assignee_id] || '';
    },

    renderError: function () {
        const message =
        '<div class="error-dialog padding-30">' +
            '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
            '<h3>Authentication failed</h3>' +
            `<p class="info">We couldn't connect to your Linear account.</p>${
                Cache.app.isAdmin() ?
                    '<button class="reconnect primary medium">Reconnect Linear</button>' +
            '<div class="divider-20"></div>' : ''
            }</div>`;

        this.$el.html(message);
    },

    renderTeams: function () {
        const team_selected = this.searchTeam(this.team_id);

        const team_items = Object.entries(this.send_options?.teams).map(
            ([id, name]) => `<li data-id="${id}" ${this.team_id === id ? 'class="selected"' : ''}>${Util.htmlEntities(name)}</li>`
        ).join('');

        this.$el.find('.region-teams').html(`
<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-team" data-append="true">
    <button type="button" class="dropdown-select">${team_selected ? Util.htmlEntities(team_selected) : '<span class="placeholder-text">No team selected</span>'}</button>
    <div>
        <div class="dropdown-search">
            <input type="text" class="solid compact" placeholder="Search by team name">
        </div>
        <ul class="dropdown dropdown-select">${team_items || ''}</ul>
    </div>
</div>
<input type="hidden" name="team_id" value="${this.team_id}">`);
    },

    renderProjects: function () {
        const project_selected = this.searchProject(this.project_id);
        const project_items = Object.entries(this.send_options?.projects?.[this.team_id] || {}).map(
            ([id, name]) => `<li data-id="${id}" ${this.project_id === id ? 'class="selected"' : ''}>${Util.htmlEntities(name)}</li>`
        ).join('');

        this.$el.find('.region-projects').html(`
<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-project" data-append="true">
    <button type="button" class="dropdown-select">${project_selected ? Util.htmlEntities(project_selected) : '<span class="placeholder-text">No project selected</span>'}</button>
    <div>
        <div class="dropdown-search">
            <input type="text" class="solid compact" placeholder="Search by project name">
        </div>
        <ul class="dropdown dropdown-select">${project_items || '<li class="disabled">No projects</li>'}</ul>
    </div>
</div>
<input type="hidden" name="project_id" value="${this.project_id}">`);
    },

    renderAssignees: function () {
        const assignee_selected = this.searchAssignee(this.assignee_id);
        const assignee_items = Object.entries(this.send_options?.users).map(
            ([id, name]) => `<li data-id="${id}" ${this.assignee_id === id ? 'class="selected"' : ''}>${Util.htmlEntities(name)}</li>`
        ).join('');

        this.$el.find('.region-assignees').html(`
<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-assignee" data-append="true">
    <button type="button" class="dropdown-select">${assignee_selected ? Util.htmlEntities(assignee_selected) : '<span class="placeholder-text">No assignee selected</span>'}</button>
    <div>
        <div class="dropdown-search">
            <input type="text" class="solid compact" placeholder="Search by assignee name">
        </div>
        <ul class="dropdown dropdown-select">${assignee_items || ''}</ul>
    </div>
</div>
<input type="hidden" name="assignee_id" value="${this.assignee_id}">`);
    },

    renderLabels: function () {
        let labels_selected = '';
        let label_items = '';

        if (this.send_options) {
            Object.keys(this.send_options.labels).forEach((label_id) => {
                label_items +=
                '<li data-id="' + label_id + '"' + (this.labels.includes(label_id) ? ' class="selected"' : '') + '>' +
                        Util.htmlEntities(this.send_options.labels[label_id]) +
                '</li>';
            });

            if (!label_items) {
                label_items = '<li>No labels</li>';
            }

            this.labels.forEach((label_id) => {
                const label = this.send_options?.labels[label_id];
                labels_selected +=
                '<span class="badge-secondary-invert">' +
                    '<span>' + Util.htmlEntities(label) + '</span>' +
                    '<input type="checkbox" class="hidden" name="labels" value="' + Util.htmlEntities(label_id) + '" checked>' +
                '</span>';
            });
        }

        const html =
        '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-label" data-append="true">' +
            '<button type="button" class="dropdown-select dropdown-select-multiple">' + (labels_selected || '<span class="placeholder-text">No labels selected</span>') + '</button>' +
            '<div>' +
                '<div class="dropdown-search">' +
                    '<input type="text" class="solid compact" placeholder="Search by label name">' +
                '</div>' +
                '<ul class="dropdown dropdown-select">' + label_items + '</ul>' +
            '</div>' +
        '</div>';

        this.$el.find('.region-labels').html(html);
    },

    render: function () {
        const content_loading = `
<div class="row-50">
    <div>
        <div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
        <div class="loader-placeholder-medium margin-bottom-20"></div>
    </div>
    <div>
        <div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
        <div class="loader-placeholder-medium margin-bottom-20"></div>
    </div>
</div>
<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
<div class="loader-placeholder-medium margin-bottom-20"></div>
<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
<div class="loader-placeholder-large margin-bottom-8"></div>
<div class="loader-placeholder-medium margin-bottom-20"></div>
<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
<div class="loader-placeholder-medium margin-bottom-20"></div>
<div class="loader-placeholder" style="width:100px;"></div>`;

        const content_form = `
<div class="row-50">
    <div class="row">
        <div class="field-label">Team <i class="fas fa-asterisk"></i></div>
        <div class="region-teams"></div>
    </div>
    <div class="row">
        <div class="field-label">Project</div>
        <div class="region-projects"></div>
    </div>
</div>
<div class="row">
    <div class="field-label">Task Title</div>
    <input type="text" name="title" maxlength="255" class="solid compact" placeholder="${Util.htmlEntities(this.title)}">
</div>
<div class="row">
    <div class="field-label">Description</div>
    <textarea name="body" class="solid compact" rows="3"></textarea>
</div>
<div class="row">
    <div class="field-label">Assignee</div>
    <div class="region-assignees"></div>
</div>
<div class="row">
    <div class="field-label">Labels</div>
    <div class="region-labels"></div>
</div>`;

        const content = `
<div class="progress-loader"></div>
<div class="mask-light" style="display:none;"></div>
<form class="form-fluid">
    <div class="modal-integration-innerscroll">
       ${this.send_options ? content_form : content_loading}
    </div>
    <div class="modal-integration-innerscroll-footer">
        <button type="submit" class="primary" ${this.send_options ? '' : 'disabled'}>Send</button>
    </div>
</form>`;

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title
            });
        }

        if (this.send_options) {
            this.renderTeams();
            this.renderProjects();
            this.renderAssignees();
            this.renderLabels();
        } else {
            this.loadOptions();
        }

        return this;
    }
});

export default Linear_Send;
